import React from "react";

export default function PermissionMatrix({
  actionColumns,
  isPermissionChecked,
  isSaving = false,
  onToggle,
  permissionRows,
}) {
  return (
    <div className="role-access__table-wrap new_role-access-table-wrap">
      <div className="role-access__table-scroll new_role-access-table-scroll">
        <table className="role-access__table new_role-access-table">
          <thead>
            <tr>
              <th className="role-access__resource-head">Module / Resource</th>
              {actionColumns.map((column) => (
                <th key={column.action}>{column.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {permissionRows.map((row) => (
              <tr key={row.resource}>
                <td className="role-access__resource-cell">
                  <div className="role-access__resource-name">{row.resourceLabel}</div>
                  <div className="role-access__resource-key">/{row.resource}</div>
                </td>
                {actionColumns.map((column) => (
                  <td
                    key={`${row.resource}-${column.action}`}
                    className="role-access__checkbox-cell"
                  >
                    <label
                      className="role-access__checkbox-label"
                      title={`${row.resourceLabel} - ${column.label}`}
                    >
                      <input
                        checked={isPermissionChecked(row.resource, column.action)}
                        className="role-access__checkbox"
                        disabled={isSaving}
                        onChange={() => onToggle(row.resource, column.action)}
                        type="checkbox"
                      />
                      <span className="role-access__checkbox-custom" />
                    </label>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
